import { FC } from 'react';
import styles from './content-header.module.scss';
import classNames from 'classnames';
import { HeaderVariations } from './types';

interface ContentHeaderProps {
  title?: string | JSX.Element;
  navigation?: JSX.Element;
  subNavigation?: JSX.Element;
  focusMode?: JSX.Element;
  actions?: JSX.Element;
  subtitle?: string | JSX.Element;
  headerVariation?: HeaderVariations;
  controlOptions?: JSX.Element;
}

const PARENT_CLASSNAME = 'content-header';
export const ContentHeader: FC<ContentHeaderProps> = ({
  title,
  actions,
  navigation,
  subNavigation,
  focusMode,
  headerVariation,
  subtitle,
  controlOptions,
}) => {
  return (
    <>
      <div
        className={classNames(styles['content-header__top-section'], {
          [styles[`content-header__top-section--${headerVariation}`]]: headerVariation,
        })}>
        <div className={styles[`${PARENT_CLASSNAME}__info-section`]}>
          <div className={styles[`${PARENT_CLASSNAME}__info-section-inner`]}>
            {subtitle && <h2 className={styles['content-header__sub-title']}>{subtitle}</h2>}
            <h1 className={styles[`${PARENT_CLASSNAME}__title`]}>{title}</h1>
          </div>
          {controlOptions}
        </div>
        <div className={styles[`${PARENT_CLASSNAME}__actions-section`]}>{actions}</div>
      </div>
      {navigation && <div>{navigation}</div>}
      {subNavigation && <div>{subNavigation}</div>}
      {focusMode}
    </>
  );
};
